/**
 * Проверяем если у товара больше одного варианта, то вешаем класс на элемент с формой товара
 * @method
 * @private
 */

export default (productFormNode, productVariants, className, isMoreThanOneVariant) => {
  if (
      productVariants && productVariants.length > 1 &&
      productVariants[0] && !!productVariants[0].option_values.length
      || isMoreThanOneVariant
  ) {
    productFormNode.classList.add(className);
  }
};
